import type { EmbedChatInstance, EmbedChatState } from "./embedTypes"

/**
 * Create initial Embed chat state
 */
export const createInitialEmbedState = (): EmbedChatState => ({
  activeChatId: null,
  chats: {}
})

/**
 * Create a new embed chat instance
 */
export const createEmbedChatInstance = (
  chatId: string,
  integrationId: string,
  sessionId: string,
  isPreview: boolean = false
): EmbedChatInstance => ({
  id: chatId,
  integrationId,
  sessionId,
  messages: [],
  isLoadingMessages: false,
  streamingMessages: {},
  isSendingMessage: false,
  shouldShowDynamicWhitespace: false,
  unreadCount: 0,
  initializationPhase: "idle",
  initializationError: null,
  isPreview,
  isNewChatroom: false,
  lastAccessedAt: Date.now(),
  topic: null,
  hasMoreHistory: false,
  isLoadingMoreMessages: false
})
